import React, { useCallback, useEffect } from 'react';

import FanZoneIndicator from '../../../components/generalComponents/FanZoneIndicator/FanZoneIndicator';
import './css/Anchor.css';

const SPECIAL_GUEST_ANCHOR_ID = 80;
const BASE_ROUTE = '/naked-news-anchor';

const Anchor = ({ anchor, isBroadcasting, isWhitelisted, fanZones, pastAnchor }) => {

  const buildAnchorLink = useCallback(() => {
    const nameArray = anchor.name.split(' ');
    let finalName = '';
    for (let i = 0; i < nameArray.length; i++) {
      finalName += `${nameArray[i]}-`;
    }

    return `${BASE_ROUTE}-${finalName.toLowerCase()}a${anchor.id}${fanZones.includes(anchor.id) ? '?filter=fanzone' : ''}`;
  }, [anchor, fanZones]);

  useEffect(() => {
    buildAnchorLink();
  }, []);

  if (anchor.id === SPECIAL_GUEST_ANCHOR_ID) {
    return null;
  }

  // pastAnchor prop is used to temporarily turn off the online indicator for past anchors; remove after broadcast testing on live
  return (
    <div className="col-md-2 col-xs-6 text-center ts">
      <div className="thumbnail">
        <a href={buildAnchorLink()}>
          <img alt={anchor.name} className="img-responsive" src={anchor.biopic} />
        </a>
        <div className="caption text-center">
          <p>{anchor.name}</p>
        </div>
        {isBroadcasting && isWhitelisted && !pastAnchor && (
          <div className="anchor-broadcast-indicator" />
        )}
        {fanZones.includes(anchor.id) && <FanZoneIndicator />}
      </div>
    </div>
  );
};

export default Anchor;
